export default class CrudTablePersistentState {
  constructor() {
    this.namespace = 'default';
    this.enabled = true;
  }
  setNameSpace(namespace) {
    this.namespace = namespace;
  }
  enable(enable) {
    this.enabled = enable;
  }
  buildKey(subject) {
    return `crudTable_${this.namespace}_${subject}`;
  }
  getDefaultSearch(filters) {
    const key = this.buildKey('Search');
    const defaultFilters =
      (this.enabled && sessionStorage.getItem(key) && JSON.parse(sessionStorage.getItem(key))) || {};
    Object.assign(defaultFilters, filters);
    return defaultFilters;
  }
  getDefaultListQuery(name) {
    const key = this.buildKey('ListQuery');
    return (
      (this.enabled && sessionStorage.getItem(key) && JSON.parse(sessionStorage.getItem(key))) || {
        limit: 20,
        page: 1,
        sort: null
      }
    );
  }
  persistListParams(listParameters) {
    if (!this.enabled) {
      return;
    }
    const listQuery = {
      limit: listParameters.query.limit,
      page: listParameters.query.page,
      sort: listParameters.query.sort
    };
    const search = {
      ...listParameters.query
    };
    delete search.condition;
    delete search.limit;
    delete search.page;
    delete search.sort;
    for (const propName in search) {
      if ((search[propName] !== 0 && !search[propName]) || search[propName].length === 0) {
        delete search[propName];
      }
    }
    sessionStorage.setItem(this.buildKey('ListQuery'), JSON.stringify(listQuery));
    sessionStorage.setItem(this.buildKey('Search'), JSON.stringify(search));
  }
}
